module.exports = __webpack_public_path__ + "media/images/payment-visa-24c5d44d2e80be81475e93977d058f49.png";